import React, { useEffect, useRef } from "react";
import neshan_map_loader from "./neshan_map_loader";

const NeshanMap = (props) => {
  const { style, options, onInit } = props;
  const mapEl = useRef(null);

  const defaultStyle = {
    width: "600px",
    height: "300px",
    margin: 0,
    padding: 0,
    background: "#eee",
  };

  const defaultOptions = {
    key: "YOUR_API_KEY",
    maptype: "dreamy",
    poi: true,
    traffic: false,
    center: [35.699739, 51.338097],
    zoom: 14,
  };

  useEffect(() => {
    neshan_map_loader({
      onLoad: () => {
        let map = new window.L.Map(mapEl.current, {   ...options });
        if (onInit) onInit(window.L, map);
      },
      onError: () => {
        console.error("Neshan Maps Error: This page didn't load Neshan Maps correctly");
      },
    });
  },[]);
  
  return <div ref={mapEl} style={{ ...defaultStyle, ...style }} />;
};


// const NeshanMap = (props) => {
//    const { lat1,lng1,mapLoad1  } = props;
//   const mapEl = useRef(null);


//   const defaultStyle = {
//     width: "600px",
//     height: "200px",
//     margin: 0,
//     padding: 0,
//     background: "#eee",
//   };
//   const style={width: "100%" , heigth: "200px"}
//   const defaultOptions = {
//     key: "web.jZsJ1ZRvwmhzt0O9kjkihz3m9txx4JomfuMdMGju",
//     maptype: "dreamy",
//     poi: true,
//     traffic: false,
//     center: [50.699739, 51.338097],
//     zoom: 4,
//   };
//   const options={
//     key: "web.jZsJ1ZRvwmhzt0O9kjkihz3m9txx4JomfuMdMGju",
//     maptype: "dreamy",
//     poi: true,
//     traffic: false,
//     center: [50.699739, 51.338097],
//     zoom: 13,
//   }
 

//   const onInit=(L, myMap) => {
//     let marker = L.marker([50.699739, 51.338097])
//       .addTo(myMap)
//       .bindPopup("<b>Hello world!</b><br>I am a popup.");
//     // myMap.on("click", function (e) {
//     //   marker.setLatLng(e.latlng);
//     // });

//     L.circle([50.699739, 51.338097], {
//       color: "red",
//       fillColor: "#f03",
//       fillOpacity: 0.5,
//       radius: 500,
//     }).addTo(myMap);
//   }

//   useEffect(() => {
//     console.log("hhbb")
    
//     alert(props.lat1); 
//   },[props.mapLoad1]);
  
//   return <div ref={mapEl} style={{ ...defaultStyle,...style }} />;
// };

export default NeshanMap;